export default "__VITE_ASSET__CxEE7vLP__"